import React, { useMemo } from 'react'
import { Connect } from './Connect';
import logoBlack from '../images/logo-black.png';
// import logoMobile from '../images/logo-mobile.png';
import qbitImg from '../images/chain-logo.png';
import queryString from "query-string";
import sLogo from '../images/s-logo.png';
import {
    Link,
    useParams,
    useLocation,
} from "react-router-dom";


export default function Header() {
    const router = useRouter();
    return (
        <header id="navbar">
            {/* <!--HEADER SECTION--> */}
            <div className="container-fluid">
                <div className="row d-flex justify-content-center">
                    <div className="col-12">
                        <nav className="navbar navbar-expand-lg navbar-light p-0">
                            <div className="container-fluid">
                                <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <a className="flex-shrink-0 navbar-brand p-0" target="_blank" rel="noreferrer" href="https://www.blockstar.site/">
                                    {/* <!--<img className="w-100 lazy" src="assets/images/logo-black.png" alt="">--> */}
                                    <img className="mob-none lazy logo-img" src={logoBlack} alt="logoblack" />
                                    <img className="mob-logo desk-none GFG" style={{ "height": "38px", "width": "38px" }} src={sLogo} alt="logoMobile" />
                                </a>

                                <div className="navbar-collapse d-none d-lg-block" id="navbarSupportedContent">
                                    {/* <!--MENU ITEMS--> */}
                                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0 justify-content-center">
                                        <li className="nav-item">
                                            <a className="nav-link p-0" aria-current="page" target="_blank" rel="noreferrer"
                                                href="https://www.blockstar.site/">Home</a>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/" className={`nav-link p-0 ${router.pathname === "/" ? "active" : ""}`} >Stake</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/my-stake" className={`nav-link p-0 ${router.pathname === "/my-stake" ? "active" : ""}`}>My Stake</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="network on-mobile mr-3">
                                    <img src={qbitImg} width="24" className="mx-2" alt="blockstar" />
                                    <span className="ml-2 hide-on-mobile">BlockStar Mainnet</span>
                                </div>
                                <Connect />
                            </div>
                        </nav>

                        {/* <!--MOBILE MENU--> */}
                        <div className="offcanvas offcanvas-start" style={{ "background": "#1f2128" }} tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                            <div className="offcanvas-header">
                                <a className="navbar-brand p-0" href="https://www.blockstar.site/" target="_blank" rel="noreferrer">
                                    <img src={logoBlack} className="lazy mobile-in-logo" alt="logo-blkc" />
                                </a>
                                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body">
                                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                    <li className="nav-item">
                                        <a className="nav-link p-0" aria-current="page" target="_blank" rel="noreferrer" href="https://www.blockstar.site/">Home</a>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/" className={`nav-link p-0 ${router.pathname === "/" ? "active" : ""}`} >Stake</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/my-stake" className={`nav-link p-0 ${router.pathname === "/my-stake" ? "active" : ""}`}>My Stake</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}


export function useRouter() {
    const params = useParams();
    const location = useLocation();

    // Return our custom router object
    // Memoize so that a new object is only returned if something changes
    return useMemo(() => {
        return {
            // For convenience add push(), replace(), pathname at top level
            push: location.push,
            replace: location.replace,
            pathname: location.pathname,
            // Merge params and parsed query string into single "query" object
            // so that they can be used interchangeably.
            // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
            query: {
                ...queryString.parse(location.search), // Convert string to object
                ...params,
            },
            // Include match, location, history objects so we have
            // access to extra React Router functionality if needed.
            location,

        };
    }, [params, location]);
}

